export function initMemberOpenCreditTxModal() {
    $(document)
        .off('click.memberOpenCreditTxModal', '.open-credit-tx-btn')
        .on('click.memberOpenCreditTxModal', '.open-credit-tx-btn', function (event) {
            event.preventDefault();
            const $btn = $(this);
            const $card = $btn.closest('.account-credit');
            const label = $.trim($card.find('.account-credit__label').first().text()) || 'Open credit';
            const $tpl = $card.find('.open-credit-tx-template').first();
            const html = $tpl.length
                ? $tpl.html()
                : '<p class="mb-0 text-muted">No open credit payments recorded for this account.</p>';

            const $modal = $('#openCreditTxModal');
            $modal.find('#openCreditTxModalLabel').text('Transaction history: ' + label);
            $modal.find('#openCreditTxModalBody').html(html);
            $modal.modal('show');
        });
}
